import { render, staticRenderFns } from "./ProductAddonForm.vue?vue&type=template&id=7d1a5bd4&"
import script from "./ProductAddonForm.vue?vue&type=script&lang=js&"
export * from "./ProductAddonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports